import { useDispatch, useSelector } from 'react-redux';
import { selectFilters } from '../Filter/selectors';
import { useDocumentContext } from './context';
import { getColumns } from './Document.columns';
import { Button } from '@storebrand-digital/pretzel';
import { CaretDownIcon, CaretUpIcon } from '@storebrand-digital/pretzel/icons';
import { filterActions } from '../Filter/reducer';
import React from 'react';
import styles from './DocumentCardListHead.module.css';

export function DocumentCardListHead() {
  const dispatch = useDispatch();
  const { sortBy, sortDirection } = useSelector(selectFilters);
  const { selectedSegmentId } = useDocumentContext();
  const columns = getColumns(selectedSegmentId);
  const sortableColumns = columns.filter((col) => col.sortable);

  return (
    <div className={styles.sortBar}>
      {sortableColumns.map((column) => {
        const isActive = sortBy === column.name;
        const iconRight = isActive
          ? sortDirection === 'ASC'
            ? CaretUpIcon
            : CaretDownIcon
          : undefined;

        return (
          <Button
            className={styles.sortButton}
            key={column.name}
            variant="tertiary"
            showDefaultIcon={false}
            {...(iconRight ? { iconRight } : {})}
            onClick={() => dispatch(filterActions.changeSortBy(column.name))}
          >
            {column.label()}
          </Button>
        );
      })}
    </div>
  );
}
